export default __webpack_public_path__ + "static/media/bg-coi-day.6532c71c.png";